<div class="section-title">
  <div class="title-group">
    <span class="title-text">{{ title }}</span>
    <span *ngIf="subtitle" class="title-subtitle">{{ subtitle }}</span>
  </div>
  <button
    qai-link
    *ngIf="showDetails"
    [disabled]="actiondisabled"
    (click)="onActionClick($event)"
    class="title-action"
  >
    {{ detailsText }}
  </button>
  <ng-content select="[headerAction]"></ng-content>
</div>
<div class="section-description" *ngIf="!!description">{{ description }}</div>
<div class="section-content">
  <ng-content></ng-content>
</div>
